import { serviceV2Key } from '../service';

export const mutationKey = {
  submitFeedback: [...serviceV2Key, 'submit-feedback'],
};
